import React, { ReactNode } from 'react';
import { colorVariables } from '../base/theme';

const styles = {
    color: `${colorVariables.textSecondary}`
};

const HintText = ({
    children,
    className,
    'data-q': dataQ
}: {
    children: ReactNode,
    className?: string,
    'data-q'?: string
}) => {
    return (
        <p className={className} style={styles} data-q={dataQ}>
            {children}
        </p>
    );
};

export default HintText;
